import { render, staticRenderFns } from "./item-form.vue?vue&type=template&id=c8d900aa&"
import script from "./item-form.vue?vue&type=script&lang=js&"
export * from "./item-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../exo_admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports